import { ISingleIdParams } from '../types/actionParams';
import { IProjectName } from '../types/IProject';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetProjectAncestorsResult extends IResult {
  projects: IProjectName[];
}

export class GetProjectAncestorsRequest extends Request<ISingleIdParams, IGetProjectAncestorsResult> {
  constructor(projectId: string) {
    super('getProjectAncestors', { id: projectId });
  }
}
